
import * as React from 'react';
import { apiRequest } from '@/utils/request';
import { useEffect, useId, useState } from 'react';

import { Button, Input, Label, Link } from '@/components/ui';
import { Form } from '@/components/business';

export function ForgotPassword({ loginEmail, onAlert, backToLogin }) {
    const emailInputId = useId();
    const
        [email, setEmail] = useState(loginEmail),
        [formFilled, setFormFilled] = useState(false),
        [loading, setLoading] = useState(false);

    useEffect(() => {
        setFormFilled(email !== '');
    }, [email]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        const data = {
            email
        };

        try {
            const response = await apiRequest('/reset_password', 'POST', data);

            if (response.status === 201) {
                onAlert(i18next.t('ui.passwords.reset_instructions'), 'success', i18next.t('common.success').capitalize());
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred');

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'));
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    return (
        <div className="tw-grid tw-gap-4">
            <Form onSubmit={handleSubmit}>
                <div className="tw-flex tw-flex-col tw-gap-1">
                    <Label htmlFor={emailInputId}>{i18next.t('ui.passwords.email_to_reset')}</Label>
                    <Input
                        id={emailInputId}
                        type="email"
                        placeholder="m@example.com"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <Button type="submit" loading={loading} fullWidth tone="secondary" disabled={!formFilled}>
                    {i18next.t('ui.actions.reset_password')}
                </Button>
            </Form>
            <Link icon="arrowLeftCircle" onClick={backToLogin} text={i18next.t('ui.passwords.back_to_login')} variant="body"/>
        </div>
    );
}
